import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import ClearIconML from '@/components/ClearIconML/index';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import { useForm, Controller } from 'react-hook-form';
import SearchIcon from '@material-ui/icons/Search';
import ReplayIcon from '@material-ui/icons/Replay';
import { useTheme } from '@material-ui/core';
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  FormHelperText,
} from '@material-ui/core';
import dayjs from 'dayjs';
import { DEFAULT_PERMITTEDGROUP } from '@/constants';
// import { useDispatch, useSelector } from 'dva';
import Button from '@material-ui/core/Button';
import DateRangePickerML from '@/components/DateRangePickerML';
import { useIntl } from 'umi';
import SearchGroupStyled from './SearchGroupStyled';

const SearchGroup = React.forwardRef((props) => {
  //过于国际化的方法
  const intl = useIntl();
  const { formatMessage } = intl;
  const { roleList = [], query } = props;
  const { handleSearch, restClick } = props;
  const specifiedDate = dayjs();
  const oneMonthAgo = specifiedDate.subtract(30, 'day').format('YYYY-MM-DD');
  const specifiedFormatDate = dayjs().format('YYYY-MM-DD');
  const { idName, permittedGroup, signUpDateEnd, signUpDateStart } = query;
  const theme = useTheme();
  const { handleSubmit, control, reset, setValue, watch, getValues } = useForm({
    defaultValues: {
      idName,
      permittedGroup: permittedGroup ?? DEFAULT_PERMITTEDGROUP,
      date: {
        startDate: signUpDateStart || oneMonthAgo,
        endDate: signUpDateEnd || specifiedFormatDate,
      },
    },
  });

  // 每个输入框清除数据
  //置空输入框
  const handleClearAuthor = () => {
    setValue('permittedGroup', '');
  };

  const watchAuthor = watch('permittedGroup');
  const [idNameValue, setIdNameValue] = useState();
  // 日期超过30天校验
  const dateDiffValid =
    dayjs(getValues('date')?.endDate).diff(
      dayjs(getValues('date')?.startDate),
      'day',
    ) > 30;
  //初始状态保持的时候
  useEffect(() => {
    if (idName) {
      setIdNameValue(idName);
    }
  }, [idName]);
  //控制日期控件的重置
  const [isReset, setIsReset] = useState(false);
  //点击搜素
  const handleSubmitSuccess = (submitData) => {
    const propsSubmitData = {
      ...submitData,
      signUpDateEnd: submitData.date?.endDate,
      signUpDateStart: submitData.date?.startDate,
    };
    delete propsSubmitData.date;

    handleSearch && handleSearch(propsSubmitData);
  };
  //点击重置
  const handleRestClick = () => {
    const resetSearch = {
      permittedGroup: DEFAULT_PERMITTEDGROUP,
      idName: '',
      date: {
        endDate: specifiedFormatDate,
        startDate: oneMonthAgo,
      },
    };
    setIdNameValue('');
    reset(resetSearch);
    setIsReset(true);
    const propsResetSearch = {
      permittedGroup: DEFAULT_PERMITTEDGROUP,
      idName: '',
      signUpDateEnd: specifiedFormatDate,
      signUpDateStart: oneMonthAgo,
    };
    restClick && restClick(propsResetSearch);
  };
  const handleSubmitFail = (errors) => {
    console.log(errors);
  };
  return (
    <SearchGroupStyled theme={theme}>
      <form onSubmit={handleSubmit(handleSubmitSuccess, handleSubmitFail)}>
        <Box className="card-content">
          <Box className="left">
            <Box className="line" mb={3}>
              <Controller
                render={(rp) => (
                  <TextField
                    name="idName"
                    variant="standard"
                    label="用户名"
                    value={rp.value ?? idNameValue}
                    onChange={(e) => {
                      setValue('idName', e.target.value);
                      setIdNameValue(e.target.value);
                      return rp.value;
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setIdNameValue('');
                              setValue('idName', '');
                            }}
                            edge="end"
                          >
                            {idNameValue ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="idName"
                variant="standard"
                control={control}
                id="basic"
                className="input"
                defaultValue={''}
              />
              <FormControl variant="standard" className="gender">
                <InputLabel>权限组</InputLabel>
                <Controller
                  as={
                    <Select
                      className="select"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">
                            <IconButton
                              className="clear-btn"
                              onClick={() => reset('mobile', '')}
                              edge="end"
                            >
                              <ClearIcon className="clear-icon" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    >
                      {roleList && roleList.length > 0 ? (
                        roleList.map((item) => (
                          <MenuItem
                            key={item.id}
                            value={item.id}
                            name={item.id}
                          >
                            {item.name}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled>暂无数据</MenuItem>
                      )}
                    </Select>
                  }
                  name="permittedGroup"
                  variant="standard"
                  control={control}
                  defaultValue=""
                />
                <ClearIconML
                  handleClick={handleClearAuthor}
                  clearValue={watchAuthor}
                ></ClearIconML>
              </FormControl>
              <FormControl variant="standard">
                <Controller
                  render={(rp) => (
                    <DateRangePickerML
                      // label="注册日期"
                      startText="开始时间"
                      endText="结束时间"
                      defaultStartDate={
                        signUpDateStart === undefined
                          ? oneMonthAgo
                          : signUpDateStart
                      }
                      defaultEndDate={
                        signUpDateEnd === undefined
                          ? specifiedFormatDate
                          : signUpDateEnd
                      }
                      resetStartDate={oneMonthAgo}
                      resetEndDate={specifiedFormatDate}
                      rp={rp}
                      onChange={() => {
                        setIsReset(false);
                      }}
                      name="custom-form-submit-name"
                      isResetDefalut={isReset}
                    />
                  )}
                  name="date"
                  rules={{
                    validate: () => {
                      const status =
                        !getValues('date').startDate ||
                        !getValues('date').endDate;
                      if (status) {
                        return true;
                      }
                      const dateStatus = dayjs(getValues('date')?.endDate).diff(
                        dayjs(getValues('date')?.startDate),
                        'day',
                      );
                      return dateStatus < 31;
                    },
                  }}
                  control={control}
                />
                <FormHelperText error={Boolean(dateDiffValid)}>
                  {dateDiffValid && '日期间隔不得大于31天'}
                </FormHelperText>
              </FormControl>
            </Box>
          </Box>
          <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              className="reset"
              onClick={handleRestClick}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'cm.member.n01.btn10' })}
            </Button>

            <Button
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'cm.member.n01.btn11' })}
            </Button>
          </Box>
        </Box>
      </form>
    </SearchGroupStyled>
  );
});

export default SearchGroup;
